module.exports = __webpack_public_path__ + "img/gravity-ui-trash-bin.d907d685.svg";